import { useQuery } from "@tanstack/react-query";
import { queryOptions } from "../../../../search/hooks";
import { sampleReportKeys } from "../../../queryKeys";
import api from "../api";

const useGetGeneralInfo = (hash?: string, uploadId?: string) => {
  const { data, isPending } = useQuery({
    ...queryOptions,
    queryKey: sampleReportKeys.generalInfo(hash, "joe", uploadId),
    queryFn: () => api.getGeneralInfo(hash, uploadId),
    select: ({ data: generalData }) => generalData
  });

  return { data, isLoading: isPending };
};

export default useGetGeneralInfo;
